'use client';

import { Children, cloneElement } from 'react';

import { usePopperContext } from './hooks';

import type { FC, ReactElement } from 'react';

export interface PopperOnClickCloseProps {
  children: ReactElement | ReactElement[];
}

export const PopperOnClickClose: FC<PopperOnClickCloseProps> = ({
  children,
  ...props
}) => {
  const { handleClose } = usePopperContext();

  return (
    <>
      {Children.map( children, (child) =>
        cloneElement( child, {
          onClick: handleClose,
          ...props,
        } ) )}
    </>
  );
};
